import classnames from 'classnames';
import Image from "@/app/[lang]/components/shared/SmartImage";
import { FiX } from 'react-icons/fi';

import style from '../style.module.scss';

interface FilterDrawerProps {
    showAvailability: boolean;
    setShowAvailability: React.Dispatch<React.SetStateAction<boolean>>;
    showStandard: boolean;
    setShowStandard: React.Dispatch<React.SetStateAction<boolean>>;
    showRapid: boolean;
    setShowRapid: React.Dispatch<React.SetStateAction<boolean>>;
    showType2: boolean;
    setShowType2: React.Dispatch<React.SetStateAction<boolean>>;
    showCcsCombo2: boolean;
    setShowCcsCombo2: React.Dispatch<React.SetStateAction<boolean>>;
    showChademo: boolean;
    setShowChademo: React.Dispatch<React.SetStateAction<boolean>>;
    chargerType2Src: string;
    chargerCcsCombo2Src: string;
    chargerChademoSrc: string;
    onClose: () => void;
    onReset: () => void;
    onApply: () => void;
}

const FilterDrawer = ({
    showAvailability,
    setShowAvailability,
    showStandard,
    setShowStandard,
    showRapid,
    setShowRapid,
    showType2,
    setShowType2,
    showCcsCombo2,
    setShowCcsCombo2,
    showChademo,
    setShowChademo,
    chargerType2Src,
    chargerCcsCombo2Src,
    chargerChademoSrc,
    onClose,
    onReset,
    onApply,
}: FilterDrawerProps) => {
    return (
        <>
            <button
                className={style.filterDrawerBackdrop}
                type="button"
                aria-label="Închide filtrele"
                onClick={onClose}
            />
            <aside className={style.filterDrawer}>
                <div className={style.filterDrawerHeader}>
                    <h3 className={style.filterDrawerTitle}>Filtre</h3>
                    <button
                        className={style.filterCloseButton}
                        type="button"
                        onClick={onClose}
                        aria-label="Închide filtrele"
                    >
                        <FiX />
                    </button>
                </div>

                <div className={style.filterDrawerBody}>
                    <section className={style.filterSection}>
                        <div className={style.toggleRow}>
                            <span>Disponibilitate</span>
                            <button
                                type="button"
                                className={classnames(style.toggleSwitch, showAvailability && style.toggleSwitchActive)}
                                onClick={() => setShowAvailability((value) => !value)}
                                aria-pressed={showAvailability}
                            >
                                <span className={style.toggleThumb} />
                            </button>
                        </div>
                        <h4 className={style.filterSectionTitle}>Tip încărcare</h4>
                        <div className={style.toggleRow}>
                            <span>Rapidă</span>
                            <button
                                type="button"
                                className={classnames(style.toggleSwitch, showStandard && style.toggleSwitchActive)}
                                onClick={() => setShowStandard((value) => !value)}
                                aria-pressed={showStandard}
                            >
                                <span className={style.toggleThumb} />
                            </button>
                        </div>
                        <div className={style.toggleRow}>
                            <span>Ultra rapidă</span>
                            <button
                                type="button"
                                className={classnames(style.toggleSwitch, showRapid && style.toggleSwitchActive)}
                                onClick={() => setShowRapid((value) => !value)}
                                aria-pressed={showRapid}
                            >
                                <span className={style.toggleThumb} />
                            </button>
                        </div>

                        <h4 className={style.filterSectionTitle}>Tip priză</h4>
                        <div className={style.toggleRow}>
                            <span className={style.toggleLabel}>
                                <Image className={style.toggleIcon} src={chargerType2Src} alt="Type 2" width={16} height={16} />
                                Type 2 22kW
                            </span>
                            <button
                                type="button"
                                className={classnames(style.toggleSwitch, showType2 && style.toggleSwitchActive)}
                                onClick={() => setShowType2((value) => !value)}
                                aria-pressed={showType2}
                            >
                                <span className={style.toggleThumb} />
                            </button>
                        </div>
                        <div className={style.toggleRow}>
                            <span className={style.toggleLabel}>
                                <Image className={style.toggleIcon} src={chargerCcsCombo2Src} alt="CCS Combo 2" width={16} height={16} />
                                CCS Combo 2
                            </span>
                            <button
                                type="button"
                                className={classnames(style.toggleSwitch, showCcsCombo2 && style.toggleSwitchActive)}
                                onClick={() => setShowCcsCombo2((value) => !value)}
                                aria-pressed={showCcsCombo2}
                            >
                                <span className={style.toggleThumb} />
                            </button>
                        </div>
                        <div className={style.toggleRow}>
                            <span className={style.toggleLabel}>
                                <Image className={style.toggleIcon} src={chargerChademoSrc} alt="CHAdeMO" width={16} height={16} />
                                CHAdeMO
                            </span>
                            <button
                                type="button"
                                className={classnames(style.toggleSwitch, showChademo && style.toggleSwitchActive)}
                                onClick={() => setShowChademo((value) => !value)}
                                aria-pressed={showChademo}
                            >
                                <span className={style.toggleThumb} />
                            </button>
                        </div>
                    </section>
                </div>

                <div className={style.filterDrawerFooter}>
                    <button className={style.filterResetButton} type="button" onClick={onReset}>
                        Resetează filtrele
                    </button>
                    <button className={style.filterApplyButton} type="button" onClick={onApply}>
                        Aplică filtre
                    </button>
                </div>
            </aside>
        </>
    );
};

export default FilterDrawer;
